import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";
import { Box, Typography } from "@mui/material";
import LoadingComponent from "../../components/LoadingComponent";

const containerStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "15px",
};

const defaultCoordinates = { lat: 40.73061, lng: -73.935242 };

function EventMapComponent({ coordinates = defaultCoordinates, height = { xs: 600, sm: 450, md: 600 } }) {
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    });

    if (loadError) return <Typography textAlign="center" color="white">Error loading maps</Typography>;
    if (!isLoaded) return <LoadingComponent fullScreen={false} />;

    return (
        <Box
            sx={{
                height,
                overflow: "hidden",
                borderRadius: 2,
                position: "relative",
            }}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={coordinates}
                zoom={14}
                options={{
                    streetViewControl: false,
                    disableDefaultUI: true,
                    gestureHandling: "none",
                    clickableIcons: false,
                    draggable: false,
                    disableDoubleClickZoom: true,
                }}
                onClick={() => {
                    const url = `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`;
                    window.open(url, '_blank', 'noopener,noreferrer');
                }}
            >
                <MarkerF position={coordinates} />
            </GoogleMap>
        </Box>
    );
}

export default EventMapComponent;